<template>
  <div>
    <v-card class="setup">
      <v-card-title>
        {{ $t('pages.setup.title') }}
      </v-card-title>
      <v-card-text>
        <form @submit.prevent="submit()">
          <component
            v-for="input in inputs"
            :key="input.key"
            :is="input.component"
            :config="input"
            v-model="form[input.key]">
          </component>
          <v-btn
            type="submit"
            primary light block ripple
            :loading="loading">
            {{ $t('pages.setup.submit') }}
          </v-btn>
        </form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Expert from '@/api/currentExpert'
  import { TextInput, DateInput, PhoneInput, CategoryInput } from '@/components/inputs'
  export default {
    data () {
      return {
        error: {},
        form: {
          category: null,
          firstName: null,
          lastName: null,
          birthday: null,
          phone: null
        }
      }
    },
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform',
        expert: 'skiliko/session/currentUser',
        loading: 'skiliko/session/isLoading'
      }),
      canEditPlatform () { return Expert.isAdmin(this.expert) && this.platform.need_informations },
      inputs () {
        return [
          this.canEditPlatform ? { key: 'category', required: true, component: CategoryInput } : null,
          { key: 'firstName', required: true, component: TextInput },
          { key: 'lastName', required: true, component: TextInput },
          { key: 'birthday', required: true, component: DateInput },
          { key: 'phone', required: true, component: PhoneInput }
        ]
          .filter(e => e)
          .map(input => ({
            ...input,
            label: this.$t(`pages.setup.labels.${input.key}`),
            errors: (this.error[input.key] || []).map(e => () => e)
          }))
      },
      expertData () {
        return {
          first_name: this.form.firstName,
          last_name: this.form.lastName,
          birthday: new Date(this.form.birthday),
          phone: this.form.phone
        }
      },
      platformData () {
        return this.canEditPlatform ? { category: this.form.category } : {}
      }
    },
    methods: {
      ...mapActions({
        updateCurrentUser: 'skiliko/session/updateCurrentUser',
        updateCurrentPlatform: 'skiliko/session/updateCurrentPlatform'
      }),
      async submit () {
        try {
          await this.updateCurrentUser({ data: this.expertData })
          if (Expert.isAdmin(this.expert)) {
            await this.updateCurrentPlatform({ data: this.platformData })
          }
          this.$router.replace({ path: this.$route.query.redirect || '/' })
        } catch (e) {
          this.error = (e.response || {}).data || {}
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .setup {
    width: 350px;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Setup.vue